/* Belle's Secrets — custom cart drawer controller */
(function () {
  var drawer = document.querySelector('[data-bs-cart-drawer]');
  if (!drawer) return;

  var itemsEl = drawer.querySelector('[data-bs-cd-items]');
  var tpl = document.querySelector('[data-bs-cd-item-template]');
  var emptyEl = drawer.querySelector('[data-bs-cd-empty]');
  var footEl = drawer.querySelector('[data-bs-cd-foot]');
  var subtotalEl = drawer.querySelector('[data-bs-cd-subtotal]');
  var drawerCount = drawer.querySelector('[data-bs-cd-count]');
  var shipEl = drawer.querySelector('[data-bs-cd-ship]');
  var shipMsg = drawer.querySelector('[data-bs-cd-ship-msg]');
  var shipFill = drawer.querySelector('[data-bs-cd-ship-fill]');
  var threshold = parseInt(drawer.getAttribute('data-free-threshold'), 10) || 0;
  var moneyFormat = (drawer.getAttribute('data-money-format') || '${{amount}}').replace(/<[^>]+>/g, '');
  var busy = false;

  /* ---- money ---- */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var m = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var val;
    switch (key) {
      case 'amount_no_decimals': val = fmt(cents, 0); break;
      case 'amount_with_comma_separator': val = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': val = fmt(cents, 2, ' ', '.'); break;
      default: val = fmt(cents, 2);
    }
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, val);
  }
  function sizedImage(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  /* ---- open / close ---- */
  var lastFocused;
  function open() {
    lastFocused = document.activeElement;
    drawer.hidden = false;
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var c = drawer.querySelector('[data-bs-cart-close]');
    if (c) c.focus();
  }
  function close() {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    window.setTimeout(function () { drawer.hidden = true; }, 400);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  /* ---- render ---- */
  function updateCounts(count) {
    if (drawerCount) drawerCount.textContent = count;
    document.querySelectorAll('[data-bs-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }
  function render(cart) {
    updateCounts(cart.item_count);
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      emptyEl.hidden = false;
      footEl.hidden = true;
      shipEl.hidden = true;
      return;
    }
    emptyEl.hidden = true;
    footEl.hidden = false;

    if (threshold > 0) {
      shipEl.hidden = false;
      var remaining = threshold - cart.total_price;
      if (remaining > 0) {
        shipMsg.innerHTML = "You're <b>" + formatMoney(remaining) + "</b> away from free shipping";
      } else {
        shipMsg.innerHTML = "You've unlocked <b>free shipping</b> ✨";
      }
      shipFill.style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
    }

    itemsEl.innerHTML = '';
    cart.items.forEach(function (it) {
      var node = tpl.content.firstElementChild.cloneNode(true);
      node.setAttribute('data-key', it.key);
      node.setAttribute('data-qty', it.quantity);
      var media = node.querySelector('.bs-cd-item__media');
      media.setAttribute('href', it.url);
      var img = node.querySelector('img');
      img.src = sizedImage(it.image, 200);
      img.alt = it.product_title || it.title;
      var titleEl = node.querySelector('.bs-cd-item__title');
      titleEl.textContent = it.product_title || it.title;
      titleEl.setAttribute('href', it.url);
      var vEl = node.querySelector('.bs-cd-item__variant');
      var vt = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) {
        vt = (vt ? vt + ' · ' : '') + it.selling_plan_allocation.selling_plan.name;
      }
      vEl.textContent = vt;
      node.querySelector('[data-bs-cd-qty]').textContent = it.quantity;
      node.querySelector('.bs-cd-item__price').textContent = formatMoney(it.final_line_price);
      itemsEl.appendChild(node);
    });
    subtotalEl.textContent = formatMoney(cart.total_price);
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); return cart; });
  }

  function change(key, qty) {
    if (busy) return;
    busy = true;
    drawer.classList.add('is-loading');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {})
      .then(function () { busy = false; drawer.classList.remove('is-loading'); });
  }

  function addToCart(formData, btn) {
    if (busy) return Promise.resolve();
    busy = true;
    if (btn) btn.classList.add('is-loading');
    drawer.classList.add('is-loading');
    return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: formData })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) { throw res.body; }
        return fetchCart();
      })
      .then(function () { open(); })
      .catch(function (err) {
        var msg = (err && err.description) || (err && err.message) || 'Sorry, this item could not be added.';
        if (btn) {
          var host = btn.closest('form') || btn.parentElement;
          var e = host.querySelector('[data-bs-form-error]');
          if (e) { e.textContent = msg; e.hidden = false; }
        }
      })
      .then(function () { busy = false; drawer.classList.remove('is-loading'); if (btn) btn.classList.remove('is-loading'); });
  }

  /* ---- item interactions ---- */
  itemsEl.addEventListener('click', function (e) {
    var item = e.target.closest('.bs-cd-item');
    if (!item) return;
    var key = item.getAttribute('data-key');
    var qty = parseInt(item.getAttribute('data-qty'), 10) || 1;
    if (e.target.closest('[data-bs-cd-remove]')) change(key, 0);
    else if (e.target.closest('[data-bs-cd-plus]')) change(key, qty + 1);
    else if (e.target.closest('[data-bs-cd-minus]')) change(key, Math.max(0, qty - 1));
  });

  /* ---- global triggers ---- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-bs-cart-toggle]');
    if (toggle) { e.preventDefault(); fetchCart().then(open); return; }
    if (e.target.closest('[data-bs-cart-close]')) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  /* ---- product form ATC ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-bs-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    addToCart(new FormData(form), btn);
  });

  window.bsCart = {
    open: function () { fetchCart().then(open); },
    close: close,
    add: addToCart,
    refresh: fetchCart
  };

  fetchCart();
})();
